import { useEffect } from "react"
import { garconClient } from "@apis/axiosClients"

export const useSuccessfulErrorInterceptor = () => {
  useEffect(() => {
    const resInterceptor = garconClient.interceptors.response.use(
      function onFulfilled(response) {
        if (response.data?.status?.toUpperCase() === "ERROR")
          return Promise.reject(
            response.data?.error_message || "API returned an error",
          )

        if (response.data?.error)
          return Promise.reject(response.data?.error || "API returned an error")

        return response
      },
      function onRejected(error) {
        return Promise.reject(error)
      },
    )

    return () => {
      garconClient.interceptors.response.eject(resInterceptor)
    }
  }, [])
}
